import { WellframeApi } from 'store/api';

export interface CompletionStat {
  completed: number;
  date: string;
  total: number;
}

export interface PhysicalActivityStat {
  active_goal_steps: number;
  active_steps: number;
  date: string;
  elapsed_seconds: number;
  goal_seconds: number;
  passive_goal_steps: number;
  passive_steps: number;
  steps: number;
}

export interface StatsResponse {
  medication_stats: CompletionStat[];
  physical_activity_stats: PhysicalActivityStat[];
  task_stats: CompletionStat[];
}

export const statsService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getStats: builder.query<StatsResponse, void>({
      query: () => '/api/v3/stats',
      providesTags: ['Stats'],
    }),
  }),
});

export const { useGetStatsQuery } = statsService;
